module.exports = __webpack_public_path__ + "components/rewards/hourly/static/logo-c4481fe9c44cdaee17a9b2f5051f1148.webp";